import { IChatHistory } from 'features/OpenRiskGPT/api/type-def';

import { IFeedback } from './type-def';

export interface UserMgmtTabs {
	count: string;
	label: string;
	value: string;
	id: number;
}

export interface IScheduledJob {
	id: number;
	jobName: string;
	cron: string;
}

export interface IExecutedJob {
	id: number;
	jobName: string;
	instancesCount: number;
	type: string;
}

export const MockScheduleList: IScheduledJob[] = [
	{
		id: 1,
		jobName: 'Job 1',
		cron: '0 0 12 ? * MON,TUE *',
	},
	{
		id: 2,
		jobName: 'Job 2',
		cron: '0 0 12 ? * MON,TUE *',
	},
	{
		id: 3,
		jobName: 'Job 3',
		cron: '0 0 12 ? * MON,TUE *',
	},
	{
		id: 4,
		jobName: 'Job 4',
		cron: '0 0 12 ? * MON,TUE *',
	},
	{
		id: 5,
		jobName: 'Job 5',
		cron: '0 0 12 ? * MON,TUE *',
	},
];

export const MockExecutedList: IExecutedJob[] = [
	{
		id: 1,
		jobName: 'Job 323',
		instancesCount: 3,
		type: 'Manual',
	},
	{
		id: 2,
		jobName: 'Job 284',
		instancesCount: 1,
		type: 'Automatic',
	},
	{
		id: 3,
		jobName: 'Job 162',
		instancesCount: 2,
		type: 'Automatic',
	},
	{
		id: 4,
		jobName: 'Job 324',
		instancesCount: 5,
		type: 'Manual',
	},
	{
		id: 5,
		jobName: 'Job 325',
		instancesCount: 6,
		type: 'Manual',
	},
];

export const mockResData: IChatHistory = {
	configuration: {
		session_type: 'ask_db',
	},

	createdAt: 'Tue, 13 Aug 2024 15:15:40 GMT',

	createdBy: 'anuradha.sahoo.lnu@pwc.com',

	id: '1184d639-4f17-495d-aae8-83894a648bc3',

	name: 'Required controls for managing [insert risk and risk level] in [insert product]',

	plugins: 'string',

	updatedAt: 'Tue, 13 Aug 2024 15:16:06 GMT',
};

export const mockModalResData: IFeedback = {
	comment: 'need more data related',

	created: 'Tue, 13 Aug 2024 15:50:22 GMT',

	createdBy: 'zdaves@risklink.com',

	id: 'd9a6c226-711f-4572-8e74-92d067ec4457',

	isLike: false,

	lastUpdated: 'Tue, 13 Aug 2024 15:50:48 GMT',

	lastUpdatedBy: 'zdaves@risklink.com',

	objectData: {
		prompt: '',

		response: '',
		reference: '',
	},

	objectId: 'd9a6c226-711f-4572-8e74-92d067ec4457',

	objectType: 'obligation-summary',

	reason: null,
};
